import React from "react";
import { profile } from "../data/profile";

// Rendered inside a dropdown from the header (see Navbar.jsx), not a routed
// page. Content mirrors the original simple dl layout — plain label/value
// pairs, no card panels — since it now lives in a compact popover.
const Contact = () => (
  <div className="w-72 rounded-2xl border border-line bg-surface p-5 shadow-lg sm:w-80">
    <h2 className="font-semibold">Contact</h2>
    <p className="mt-1 text-sm text-muted">
      Shoot me an email and I'll get back to you.
    </p>

    <div className="mt-4 flex flex-col gap-2">
      <a
        href={`mailto:${profile.email}`}
        className="rounded-full bg-fg px-4 py-2.5 text-center text-sm font-semibold text-bg transition-opacity duration-100 hover:opacity-80 active:translate-y-px"
      >
        Email me
      </a>
    </div>

    <dl className="mt-5 grid gap-4 border-t border-line pt-4">
      <div>
        <dt className="font-mono text-xs uppercase tracking-widest text-faint">
          Email
        </dt>
        <dd className="mt-1 text-sm">
          <a
            href={`mailto:${profile.email}`}
            className="underline-offset-4 hover:underline"
          >
            {profile.email}
          </a>
        </dd>
      </div>
      <div>
        <dt className="font-mono text-xs uppercase tracking-widest text-faint">
          Location
        </dt>
        <dd className="mt-1 text-sm">{profile.location}</dd>
      </div>
    </dl>
  </div>
);

export default Contact;
